import React from 'react';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import SEO from '@nubank/www-latam-commons/components/SEO/SEO';

import {
  domain, images, baseBreadcrumb, corporateContactData,
} from '../../utils/seo';

const FAQSEO = () => {
  const { formatMessage } = React.useContext(NuDsContext);
  const {
    contentType,
    title,
    description,
  } = formatMessage({ id: 'cms.seo' });

  const typeInUpperCase = contentType.toUpperCase();

  const titleKey = `FAQ.${typeInUpperCase}.HEAD.TITLE`;

  const pageTitle = formatMessage({ id: titleKey }, { title });

  return (
    <SEO
      pageTitle={pageTitle}
      description={description}
      breadcrumbTitle={title}
      domain={domain}
      images={images}
      baseBreadcrumb={baseBreadcrumb}
      corporateContactData={corporateContactData}
      siteName="Nu"
    />
  );
};

export default FAQSEO;
